import { ChangeDetectorRef, Injectable, Injector } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductCaptureComponent } from 'src/app/product-capture/product-capture.component';
import { ProductCaptureService } from 'src/app/product-capture/services/product-capture.service';
import { DcAlertInnerService } from 'src/app/ui-kit/dc-alert-inner/dc-alert-inner.service';
import { KeyDatesModalComponent } from './key-dates-modal.component';
import { KeyDatesSnapshotService } from '../key-dates-snapshot.service';

@Injectable({
  providedIn: ProductCaptureComponent,
})
export class KeyDatesModalService {
  constructor(public ngbModal: NgbModal, private _injector: Injector) {}

  open(props: any): Promise<any> {
    const modalRef = this.ngbModal.open(KeyDatesModalComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      windowClass: 'xlScrollableModal',
      injector: this._injector,
    });
    modalRef.componentInstance.setDialogProps(props);
    return modalRef.result;
  }

  updateKeyDatesValuesNoModal(props: any): void {
    const fb = this._injector.get(UntypedFormBuilder);
    const cd = this._injector.get(ChangeDetectorRef);
    const productCaptureService = this._injector.get(ProductCaptureService);
    const dcAlertInnerService = this._injector.get(DcAlertInnerService);
    const keyDatesSnapshotService = this._injector.get(KeyDatesSnapshotService);
    const component = new KeyDatesModalComponent(
      null,
      fb,
      cd,
      productCaptureService,
      dcAlertInnerService,
      keyDatesSnapshotService
    );
    component.setDialogProps(props);
    component.ngOnInit();

    setTimeout(() => {
      component.save();
    });
  }
}
